import { Select } from '@iqueue/ui-kit'
import FabricatorPresenter from '../../api/fabricatorPresenter'
import { useCallback, useRef, useEffect, useState } from 'react'
import { t } from '../../hooks/useTranslate'

export default function PickSensorModel({
  name = 'modelId',
  value,
  ...props
}) {
  const cache = useRef({ indexed: {} })
  const [models, setModels] = useState([])

  const render = useCallback((id) => {
    const item = cache.current.indexed[id]
    return {
      id: id,
      title: item?.name,
    }
  }, [t])

  const fetchData = useCallback(async () => {
    const data = await FabricatorPresenter.read()
    const indexed = {}

    const modelIds = data.flatMap((fabricator) => {
      return (fabricator.models || [])
        .filter((model) => model.name)
        .map((model) => {
          indexed[model.id] = model
          return model.id
        })
    })

    cache.current.indexed = indexed
    setModels(modelIds)
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  return <Select
    name={ name }
    entries={ models }
    render={ render }
    value={ value }
    allowSearch
    { ...props }
  />
}
